import PropTypes from 'prop-types';

import { Helmet } from 'core/libs/helmet';

import { resolveScopedStyles } from 'core/utils/styled-jsx';
import isNotEmptyReactElementContent from 'core/utils/content';

import H3 from '../H3';

import Card1 from 'core/components/Amp/cards/Card1';


function AmpDrum(props) {
  const {
    content,
    title,
    headerComponent: Header,
    interitemSpacing,
    card,
  } = props;

  if (!content?.length) return null;

  const scoped = resolveScopedStyles(
    <scope>
      <style jsx>{`
        :global(.amp-carousel-slide)
          margin-left ${interitemSpacing}px
        .title
          margin-bottom ${interitemSpacing}px
      `}</style>
    </scope>
  );

  const Card = card ?? Card1;

  return (
    <div>
      <Helmet>
        <script
          async='async'
          custom-element='amp-carousel'
          src='https://cdn.ampproject.org/v0/amp-carousel-0.2.js'
        />
      </Helmet>
      {isNotEmptyReactElementContent(title) && (
        <Header className={scoped.wrapClassNames('title')}>
          {title}
        </Header>
      )}
      <amp-carousel
        height='250'
        layout='fixed-height'
        type='carousel'
      >
        {content.map((cardProps, i) => <Card key={i} content={cardProps} />)}
      </amp-carousel>
      <scoped.styles />
    </div>
  );
}

AmpDrum.propTypes = {
  content: PropTypes.array.isRequired,
  headerComponent: PropTypes.func,
  title: PropTypes.string,
  interitemSpacing: PropTypes.number,
  card: PropTypes.func,
};

AmpDrum.defaultProps = {
  headerComponent: H3,
  interitemSpacing: 10,
};

export default AmpDrum;
